/**
 * Corporate card accounts (FT3-U10, FIN-FR-028).
 *
 * Exported as `EXPENSE_CARD_ACCOUNT_ROUTES` for the wave's INT packet to spread
 * into the router; this packet does not own `router/index.ts` or the nav.
 * Reading needs `expense.card.read` (`GET /card-accounts`); the screen offers
 * creation only to `expense.card.manage` (`POST /card-accounts`).
 */

import type { RouteRecordRaw } from 'vue-router'

import { EXPENSE_PERMISSIONS } from '@/modules/expense/permissions'

export const EXPENSE_CARD_ACCOUNT_ROUTES: RouteRecordRaw[] = [
  {
    path: '/expense/card-accounts',
    name: 'expense-card-accounts',
    component: () => import('@/modules/expense/card-accounts/CardAccountsView.vue'),
    meta: {
      titleKey: 'expense.routeTitles.cardAccounts',
      permission: EXPENSE_PERMISSIONS.cardRead,
    },
  },
]
